import { render, staticRenderFns } from "./QuickLocationTypeForm.vue?vue&type=template&id=71a06a0c&"
import script from "./QuickLocationTypeForm.vue?vue&type=script&lang=js&"
export * from "./QuickLocationTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports